module.exports = __webpack_public_path__ + "img/model-2.95611f0f.png";